export default {
	'history.history': 'Історія',
	'history.noTask': 'Без завдання',
};
